import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, PLATFORM_ID, Renderer2 } from '@angular/core';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { SchemaService } from '../../../shared/services/schema.service';
import { MatExpansionModule } from '@angular/material/expansion';
import { SafehtmlPipe } from '../../../shared/pipes/safehtml.pipe';

@Component({
  selector: 'app-faq-page',
  standalone: true,
  imports: [MatExpansionModule, CommonModule, SafehtmlPipe],
  templateUrl: './faq-page.component.html',
  styleUrl: './faq-page.component.scss'
})
export class FaqPageComponent {
  @Input('faqData') faqData: any
  isFirst = true;
  @Input('qaList') qaList: any;

  script:any;
  actualSchemaValue:any;
  structuredData!: SafeHtml;

  constructor(  private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    private schemaService: SchemaService,
    private sanitizer: DomSanitizer, @Inject(PLATFORM_ID) private platformId: Object) { }

  ngOnInit(): void {
    this.faqData.forEach((ele: { answer: any; question: any; }) => {
      if(ele && (ele.answer || ele.question)){
      }else{}
    })
  }

 
  }
